import React, { FC } from 'react';
import { InputAdornment, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  safe: {
    color: theme.palette.grey[600],
  },
  warning: {
    color: theme.palette.warning.main,
  },
  error: {
    color: theme.palette.error.main,
  },
}));

interface IProps {
  length: number;
  limit: number;
}

const TextCounter: FC<IProps> = ({ length, limit }) => {
  const classes = useStyles();

  const difference = limit - length;
  const className = classNames({
    [classes.safe]: difference >= 21,
    [classes.warning]: difference <= 20,
    [classes.error]: difference < 0,
  });

  return (
    <InputAdornment variant="filled" position="end">
      <Typography className={className} variant="overline">
        {length}/{limit}
      </Typography>
    </InputAdornment>
  );
};

export default TextCounter;
